import { useEffect, useState } from 'react';
import coreAxios from 'src/utils/core-axios';

// ----------------------------------------------------------------------
// GRN Hotmix on/off switch for the logged-in user's company.
//
// The menu is built in several places (vertical / mini / horizontal nav and the
// search bar), so the answer is fetched ONCE per page load and shared.
// While loading, or if anything fails, the answer is "off" — the menu stays
// hidden (fail-safe). A change in the DB shows up after a page refresh.
// ----------------------------------------------------------------------

const EMPTY_INFO = { isGrnHotmixEnabled: false, companyId: null, companyName: null };

let cachedToken = null;
let cachedPromise = null;

const getToken = () => {
  try {
    const details = JSON.parse(localStorage.getItem('loginDetails'));
    return details?.token || null;
  } catch (error) {
    return null;
  }
};

// { isGrnHotmixEnabled, companyId, companyName }
export const fetchHotmixInfo = () => {
  const token = getToken();
  if (!token) return Promise.resolve(EMPTY_INFO);

  if (cachedToken !== token || !cachedPromise) {
    cachedToken = token;
    cachedPromise = coreAxios
      .get('/api/core/hotmix/enabled', { headers: { Authtoken: token } })
      .then((response) => ({ ...EMPTY_INFO, ...(response?.data?.Details || {}) }))
      .catch(() => {
        // allow a retry on the next call instead of caching a failure forever
        cachedPromise = null;
        return EMPTY_INFO;
      });
  }
  return cachedPromise;
};

export function useHotmixEnabled() {
  const [state, setState] = useState({ loading: true, enabled: false, info: EMPTY_INFO });

  useEffect(() => {
    let active = true;
    fetchHotmixInfo().then((info) => {
      if (active) setState({ loading: false, enabled: !!info.isGrnHotmixEnabled, info });
    });
    return () => {
      active = false;
    };
  }, []);

  return state;
}
